<template>
        <a :href="url" v-if="url" class="btn btn-default" style="width: 150px">
            <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> VOLTAR
        </a>
        <a @click="back()" v-else class="btn btn-default" style="width: 150px">
            <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> VOLTAR
        </a>
</template>
<script>
export default {
    props: {
        url: {
            default: null
        }
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        back() {
            window.history.back();
        }
    }
};
</script>
